// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh4:not(.collapsed) > .closed[data-v-632a3086]\n{\n  display: none;\n}\nh4.collapsed > .opened[data-v-632a3086]\n{\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
